import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';



@Injectable({
    providedIn: 'root'
})
export class ShowVentasGuardService {

    constructor(public router: Router) {}

    canActivate(): boolean | UrlTree {

        if (!environment.features.showVentas) {
            return this.router.parseUrl('/login');
        }

        return true;
    }
}
